
const digest = 'aac3561714537248aa6707a7ef82c75317674451ff111eb51478e87e62966551';
const classes = {"pulseEffect":"_pulse-effect_1345u_18","pulse":"_pulse_1345u_18"};
const css = `@keyframes _pulse_1345u_18 {
  0% {
    transform: scale(0.98);
  }
  25% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.98);
  }
  75% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.98);
  }
}
._pulse-effect_1345u_18 {
  animation: _pulse_1345u_18 1s ease-in-out 2;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  